export default "__VITE_ASSET__50d956f3__"